import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Avatar from "@material-ui/core/Avatar";
import Paper from "@material-ui/core/Paper";
import { Typography } from "@material-ui/core";

import Colors from "../../constants/Colors";

import QuoteIcon from "./QuoteIcon";
import DecorationSvg from "./DecorationSvg";

const styles = theme => ({
  main: {
    position: "relative",
    overflow: "hidden",
    width: "48%",
    height: 80,
    // flex: 1,
    padding: 15,
    borderRadius: 20,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "center",
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8"
  },
  root: {
    width: "100%",
    minWidth: 150,
    height: 250,
    backgroundColor: theme.palette.background.paper
  },
  bold: {
    fontWeight: 500,
    marginBottom: 10
  },
  box: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    flex: 1,
    padding: 5,
    flexDirection: "column",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  rating: {
    color: Colors.main,
    marginTop: 10,
    fontWeight: 500
  },
  decorationSvg: {
    position: "absolute",
    right: -300,
    bottom: -280
  },
  quote: {
    height: "100%",
    alignItems: "center",
    justifyContent: "flex-start",
    display: "flex",
    marginLeft: 15,
    // width: "75%",
    flex: 3
  },
  quoteIcon: {
    // flex: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  },
  quoteText: {
    fontWeight: 500
  },
  rightSection: {
    display: "flex",
    flex: 1
  }
});

const BestAction = ({ title, category, rating, classes }) => {
  return (
    <Paper className={classes.main}>
      <div className={classes.quoteIcon}>
        <QuoteIcon />
      </div>
      <div className={classes.quote}>
        <Typography classes={{ root: classes.quoteText }} align="justify">
          {`« ${title} »`}
        </Typography>
      </div>
      <div className={classes.rightSection}>
        <div className={classes.decorationSvg}>
          <DecorationSvg />
        </div>
      </div>
    </Paper>
  );
};

export default withStyles(styles)(BestAction);
